import axios from 'axios'

const walterIAApi = axios.create({
	baseURL: process.env.VUE_APP_WALTERIA_API || 'https://api-walteria.smartforest.com.br',
})

walterIAApi.interceptors.request.use((config) => {
	const token = localStorage.getItem('jwt')
	if (token) config.headers.Authorization = token
	return config
})

walterIAApi.interceptors.response.use(
	(r) => r,
	(error) => {
		if (error.response?.status === 401) window.location.href = '/login'
		return Promise.reject(error)
	},
)

export default walterIAApi
